import {envConfig} from './env'
import localStorageKeys from './localStorageKeys'

const {siteUrl, locale} = envConfig

const navigateToSignIn = () => {
    window.location.href = siteUrl + 'sign-in/?logout=true'
}

const getNavigationUrl = (url, params, value) => {
    return url.replace(params, value)
}

const getLocalizedPath = routes => {
    const lang = localStorage.getItem(localStorageKeys.LANGUAGE)
    const isDefaultLang = !lang || lang === locale

    return isDefaultLang
        ? routes[1]
        : getNavigationUrl(routes[0], ':lang', lang)
}

export const stripLangPrefix = (path) => {
    return path.replace(/^\/[a-z]{2}(?=\/)/, '')
}

export default {
    navigateToSignIn,
    getNavigationUrl,
    getLocalizedPath
}
